import React, { useEffect, useState } from "react";
import apiCDS from "../../services/apiCDS";
import Container from "../../components/Container";
import CardsGridContainer from "../../components/CardsGridContainer";
import LoadingSpinner from "../../components/LoadingSpinner";
import Banner from "../../components/Banner";
import PageTitle from "../../components/PageTitle";

export default function Popular() {
  const [contents, setContents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getContents = async () => {
      const response = await apiCDS.get("/courses/populars");
      setContents(response.data);
      setLoading(false);
    };

    getContents();

    return setContents([]);
  }, []);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <Container type={"clean"}>
      <Banner />

      <PageTitle>{"Top 10 / Populares"}</PageTitle>
      <CardsGridContainer content={contents} />
    </Container>
  );
}
